// Slice B2.4-D — best-effort client POST for peek-fire persistence.
// Mirrors extract-telemetry discipline: failure must not affect dock behavior.

import type { ActivityDockPeekEventDetail } from "@/components/activity/activityDockPeekEvent";
import type { BucketId } from "@/components/shell/modes/bucketsRegistry";
import { readWorkspaceOrgIdFromStorage } from "@/lib/workspaceOrgStorage";

const PEEK_TELEMETRY_PATH = "/api/activity-dock/peek-telemetry";

export type PersistPeekTelemetryArgs = {
  detail: ActivityDockPeekEventDetail;
  bucketId: BucketId | null;
  accessToken: string;
};

/**
 * Fire-and-forget persist. Swallows network / 4xx / 5xx — the dock peek
 * lifecycle does not await this call.
 */
export function persistActivityDockPeekTelemetry(args: PersistPeekTelemetryArgs): void {
  const orgId = readWorkspaceOrgIdFromStorage();
  const body = {
    reasonSectionId: args.detail.reasonSectionId,
    mode: args.detail.mode,
    bucketId: args.bucketId,
    assistLevel: args.detail.assistLevel,
    ts: args.detail.ts,
    organizationId: orgId,
  };

  void fetch(PEEK_TELEMETRY_PATH, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${args.accessToken}`,
      ...(orgId ? { "X-Workspace-Organization-Id": orgId } : {}),
    },
    body: JSON.stringify(body),
  }).catch(() => {
    // Degraded mode — table missing or offline; peek still worked locally.
  });
}
